import {
  type RemixiconComponentType,
  RiArchive2Line,
  RiArchiveStackLine,
  RiBox3Line,
  RiRecordCircleLine,
  RiStackLine
} from '@remixicon/react'

import type { ShippingUnitKind } from '@/utils/packing-list'

/** One icon per shipping-unit kind, so a unit reads at a glance on paper and on screen. */
const ICONS: Record<ShippingUnitKind, RemixiconComponentType> = {
  SKD: RiArchiveStackLine,
  BDL: RiStackLine,
  BX: RiBox3Line,
  CL: RiRecordCircleLine,
  PKG: RiArchive2Line
}

export const ShippingUnitIcon = ({ kind, className }: { kind: ShippingUnitKind; className?: string }) => {
  const Icon = ICONS[kind]
  return (
    <Icon
      aria-hidden
      className={className}
    />
  )
}
